import { Outlet } from "react-router-dom";
import { useAuth } from "../../Services/AuthContext";
import { useState } from "react";
import SidebarLoinMagasin from "../SideBar/sidebarLoinMagasin";
import MagasinLoinHeader from "../Headers/MagasinLoinHeader";
import useAutoAlerteSonore from "../../Services/Alert";

const MagasinLoinLayout=()=>{
    const {user}=useAuth();
    // const isAdmin = !!user?.roles.includes("ROLE_ADMIN");
    const[iscollapsed]=useState<boolean>(true);
    useAutoAlerteSonore()
    
    return (
        <>
        <MagasinLoinHeader   />
        <div className="magasin-loin-layout" >
            <SidebarLoinMagasin />
            <main className={`magasin-loin-main ${iscollapsed ? 'collapsed' : ''}`}>
            <Outlet /> 
            </main>
        </div>
        </>
    );
    }
export default MagasinLoinLayout;